<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-dark">
      <img class="navbar-brand logo" src="../assets/logo/blood-bank-logo.png" alt="Blood Bank Logo">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-navbar" aria-controls="main-navbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="main-navbar" ref="mainNavbar">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link :to="{ name: 'home'}" class="nav-link" @click.native="closeNavbar()">HOME</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'findBlood'}" class="nav-link" @click.native="closeNavbar()">NEED BLOOD</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'donation'}" class="nav-link" @click.native="closeNavbar()">DONATE BLOOD</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'heroPet'}" class="nav-link" @click.native="closeNavbar()">HEROPET</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'about'}" class="nav-link" @click.native="closeNavbar()">ABOUT</router-link>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link"
              href="https://vremind.co/pet-owner/login"
              target="_blank"
              rel="norefferer"
              style="width:128px">Login</a>
          </li>
          <li class="nav-item">
            <a class="nav-link btn btn-outline-secondary my-2 my-sm-0"
              href="https://vremind.co/pet-owner/register"
              target="_blank"
              rel="norefferer"
              style="width:128px">Sign up</a>
          </li>
        </ul>
      </div>
    </nav>
    <router-view/>
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            © 2019 iTaam
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MainView',
  methods: {
    closeNavbar: function () {
      this.$refs.mainNavbar.classList.remove('show')
    }
  },
  created () {
    this.$store.dispatch('getBloodCollectionData')
  }
}
</script>

<style scoped lang="scss">
.navbar {
  position: absolute;
  background: $primary-dark;
  width: 100%;
  z-index: 1000;
  .logo {
    width: 70px;
    margin: 0 1rem;
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .navbar {
    background: $clear;
    .logo {
      width: 100px;
      margin: 0 3rem;
    }
  }
}
.footer {
  padding: 2rem 0;
  background-color: $primary-dark;
  color: white;
}
.footer-link-list {
  list-style: none;
  span {
    font-size: $h5-font-size;
    line-height: 2;
  }
  a {
    &:link {
      text-decoration: none;
    }
    &:visited {
      text-decoration: none;
    }
    &:hover {
      text-decoration: none;
    }
    &:active {
      text-decoration: none;
    }
  }
}
</style>
